import axiosInstance from '../../Helpers/api_helper';

export const signUpParticipant = async (
  fullName: string,
  email: string,
  password: string
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      'api/v1/participants/signup',
      {
        fullName: fullName,
        email: email,
        password: password,
        role: 'applicant'
      }
    );
    return response.data;
  } catch (error: any) {
    console.error('Error signing up participant:', error.message);
    throw error;
  }
};
